/* eslint-disable no-tabs */
import './bootstrap';
//import for detail journal
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';
import './assets/css/style.css';
import '../css/app.css';
import "../css/admi-theme.css";

import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { createInertiaApp } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";

import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ThemeContext } from "./utility/context/ThemeColors";
import { Toaster } from "react-hot-toast";
import Spinner from "./@core/components/spinner/Fallback-spinner";
import themeConfig from "./configs/themeConfig";

createInertiaApp({
	resolve: (name) =>
		resolvePageComponent(
			`./Pages/${name}.jsx`,
			import.meta.glob("./**/*.jsx")
		).then((page) => {
			// no default layout here; pages opt-in per page
			return page;
		}),
	setup({ el, App, props }) {
		createRoot(el).render(
			<Provider store={store}>
				<Suspense fallback={<Spinner />}>
					<ThemeContext>
						<App {...props} />
						<Toaster
							position={themeConfig.layout.toastPosition}
							toastOptions={{ className: "react-hot-toast" }}
						/>
					</ThemeContext>
				</Suspense>
			</Provider>
		);
	},
});